import type { ActivityResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toActivity } from './toActivity';

// Builds a normalized `Data.Activity` domain from a list of Activity DTOs.
// Mirrors the shape of the other domain transformers — iterate the DTO list,
// map each entry via `toActivity`, and accumulate into the normalized domain
// with `mutateAdd` for performance over bulk inserts.
function toActivityDomain(args: { dtos: ActivityResponse[] }) {
  const { dtos } = args;

  const activityDomain: NormalizedDomain<Data.Activity> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const activity = toActivity(item);
      domainUtility.mutateAdd(activityDomain, activity);
    },
  });

  return { activityDomain };
}

export { toActivityDomain };
